import * as React from "react";
import { Field, useFormikContext } from "formik";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
import { seriesFunctionForMetric } from "../metric/MetricElement";
const directionOptions = [
  { label: "Ascending", value: "Ascending" },
  { label: "Descending", value: "Descending" }
];
const formatSeries = (metric) => {
  const seriesFunction = seriesFunctionForMetric(metric);
  return {
    label: metric.name || seriesFunction,
    field: seriesFunction
  };
};
const formatGrouping = (grouping) => grouping.fields;
const Sort = React.memo(({ index }) => {
  var _a, _b;
  const { values, setFieldValue } = useFormikContext();
  const { metrics = [], groupBy: { groupings = [] } = {} } = values;
  const otherSorts = (_b = (_a = values == null ? void 0 : values.sort) == null ? void 0 : _a.filter((_, idx) => index !== idx)) != null ? _b : [];
  const hasMetrics = otherSorts.find((s) => s.type === "metric");
  const hasGroupings = otherSorts.find((s) => s.type === "groupBy");
  const metricsOptions = hasGroupings ? [] : metrics.filter((metric) => metric.function !== "latest").map(formatSeries).map(({ field, label }) => ({
    type: "metric",
    field,
    label
  }));
  const rowPivotOptions = hasGroupings || hasMetrics ? [] : groupings.filter((grouping) => grouping.direction === "row").flatMap(formatGrouping).map((groupBy) => ({
    type: "groupBy",
    field: groupBy,
    label: groupBy
  }));
  const options = [...metricsOptions, ...rowPivotOptions];
  const numberIndexedOptions = options.map((option, idx) => ({ label: option.label, value: idx }));
  const currentSort = values.sort[index];
  const optionIndex = options.findIndex(
    (option) => option.type === currentSort.type && option.field === currentSort.field
  );
  const selectedOption = optionIndex > -1 ? optionIndex : void 0;
  const invalidSort = selectedOption === void 0 && "field" in currentSort;
  return /* @__PURE__ */ React.createElement("div", { "data-testid": `sort-element-${index}` }, /* @__PURE__ */ React.createElement(Field, { name: `sort.${index}.field` }, ({ field: { name, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(Input, { id: "field-select", label: "Field", error, labelClassName: "col-sm-3", wrapperClassName: "col-sm-9" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      options: invalidSort ? [{ label: currentSort.field, value: 0 }] : numberIndexedOptions,
      disabled: invalidSort,
      allowCreate: invalidSort,
      clearable: false,
      name,
      value: invalidSort ? 0 : selectedOption,
      placeholder: "Specify field/metric to be sorted on",
      "aria-label": "Select field for sorting",
      size: "small",
      onChange: (newValue) => {
        const option = options[newValue];
        setFieldValue(`sort.${index}.type`, option.type);
        onChange({ target: { name, value: option.field } });
      }
    }
  ))), /* @__PURE__ */ React.createElement(Field, { name: `sort.${index}.direction` }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "direction-select",
      label: "Direction",
      error,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        options: directionOptions,
        disabled: invalidSort,
        clearable: false,
        name,
        "aria-label": "Select direction for sorting",
        value,
        size: "small",
        onChange: (newValue) => {
          onChange({ target: { name, value: newValue } });
        }
      }
    )
  )));
});
export default Sort;
